import React from 'react'
import { withRouteData, Link } from 'react-static'

import HeroBase from './HeroBase'
import { trackedClick } from '../utils'

const HeroIntent = ({ contentType = 'text', category = {}, intent = {} }) => (
    <HeroBase center>
        <div className="header__breadcrumbs">
            <nav className="breadcrumbs">
                <Link
                    className="breadcrumbs__link"
                    href="/api-platform"
                    to="/api-platform"
                    title="Intent Catalog"
                    onClick={trackedClick('Intent Breadcrumbs clicked', {
                        source: 'Intent breadcrumbs',
                        title: 'Intent Catalog',
                    })}
                >
                    Intent&nbsp;Catalog
                </Link>
                <span className="breadcrumbs__sep"> / </span>
                <Link
                    className="breadcrumbs__link"
                    href="/api-platform/ai"
                    to="/api-platform/ai"
                    title="AI"
                    onClick={trackedClick('Intent Breadcrumbs clicked', {
                        source: 'Intent breadcrumbs',
                        title: 'AI',
                    })}
                >
                    AI
                </Link>
                <span className="breadcrumbs__sep"> / </span>
                <Link
                    className="breadcrumbs__link"
                    href={`/api-platform/ai/${contentType}`}
                    to={`/api-platform/ai/${contentType}`}
                    title={category.name}
                    onClick={trackedClick('Intent Breadcrumbs clicked', {
                        source: 'Intent breadcrumbs',
                        title: category.name,
                    })}
                >
                    {category.name || 'Text'}
                </Link>
                <span className="breadcrumbs__sep"> / </span>
                {intent.url
                    .split('/')[2]
                    .replace(/\b\w/g, l => l.toUpperCase()) || 'Translate'}
            </nav>
        </div>
        <h1 className="hero__title h1">
            {intent.title || 'Machine Translation'}
        </h1>
        <p className="hero__text">
            {intent.description ||
                'Translate text from one language to&nbsp;another.'}
        </p>
    </HeroBase>
)

export default withRouteData(HeroIntent)



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/HeroIntent.jsx